import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import {
  IActivityLog,
  IReviewerFeedback,
  IRevisionRound,
  ISubmissionFile
} from '@publishing-engine/domain/models';
import { useState } from 'react';
import { EditorialRevisionContextModal } from '../modals/editorial/RevisonContext';
import _ from 'lodash';

export const SubmissionRevision: React.FC<{
  changes: IActivityLog;
}> = ({ changes }) => {
  const [show, setShow] = useState(false);
  const onClose = () => setShow(false);

  let payload;
  const { submissionContextId } = changes;

  switch (changes.type) {
    case 'RevisionRequested': {
      const { submission } = (changes?.changes ?? []).reduce((acc, change) => {
        const [k, v] = Object.entries(change)[0] ?? ['', ''];
        return _.set(acc, k, v);
      }, {}) as {
        submission: {
          editorComment: string;
          revisionSeverity: string;
          editorAttachments: ISubmissionFile[];
          reviews: IReviewerFeedback[];
        };
      };

      payload = {
        editorialComment: submission?.editorComment,
        editorialAttachments: submission?.editorAttachments,
        severity: submission?.revisionSeverity,
        reviewerOriginalFeedback: submission?.reviews
      };

      break;
    }
    case 'EditorialImmediateRevisionRequested': {
      payload = {
        editorialComment: changes?.editorComment
      };
      break;
    }
  }

  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'flex-start'}
      gap={2}
    >
      <Text noOfLines={3}>{payload?.editorialComment}</Text>
      <ButtonText onClick={() => setShow(true)}>View Full Details</ButtonText>

      {show && (
        <EditorialRevisionContextModal
          role="editorial"
          submissionId=""
          submissionContextId={submissionContextId}
          onClose={onClose}
          defaultData={payload as IRevisionRound}
        />
      )}
    </Flex>
  );
};
